<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg width="39" height="33" viewBox="0 0 39 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_525_174)">
              <path
                d="M32.8463 0H6.15368C4.97895 0 4 0.986779 4 2.17091V22.5315C4 23.7156 4.97895 24.7024 6.15368 24.7024H32.8463C34.0211 24.7024 35 23.7156 35 22.5315V2.17091C35 0.953886 34.0211 0 32.8463 0ZM13.2021 2.2367C13.7242 2.2367 14.1158 2.6643 14.1158 3.15769C14.1158 3.68397 13.6916 4.07869 13.2021 4.07869C12.68 4.07869 12.2884 3.65108 12.2884 3.15769C12.2558 2.63141 12.68 2.2367 13.2021 2.2367ZM10.3958 2.2367C10.9179 2.2367 11.3095 2.6643 11.3095 3.15769C11.3095 3.68397 10.8853 4.07869 10.3958 4.07869C9.87368 4.07869 9.48211 3.65108 9.48211 3.15769C9.44947 2.63141 9.87368 2.2367 10.3958 2.2367ZM7.55684 2.2367C8.07895 2.2367 8.47053 2.6643 8.47053 3.15769C8.47053 3.68397 8.04632 4.07869 7.55684 4.07869C7.06737 4.07869 6.64316 3.65108 6.64316 3.15769C6.64316 2.63141 7.06737 2.2367 7.55684 2.2367ZM32.2263 21.7091C32.2263 21.8078 32.1611 21.8736 32.0632 21.8736H6.93684C6.83895 21.8736 6.77368 21.8078 6.77368 21.7091V6.34828H32.2263V21.7091Z"
                fill="#265D91" />
              <path
                d="M11.5045 15.4267H14.8329C15.2897 15.4267 15.714 15.1964 15.9424 14.7688L17.1497 12.6966L20.7066 18.7159C20.935 19.1107 21.3592 19.3738 21.8161 19.3738C22.2729 19.3738 22.6971 19.1435 22.9255 18.7159L24.8834 15.3938H27.4613C28.1792 15.3938 28.7666 14.8017 28.7666 14.0781C28.7666 13.3544 28.1792 12.7624 27.4613 12.7624H24.1655C23.7087 12.7624 23.2845 12.9926 23.0561 13.4202L21.8487 15.4925L18.2919 9.47311C17.835 8.68369 16.5297 8.68369 16.0403 9.47311L14.0824 12.7953H11.5045C10.7866 12.7953 10.1992 13.3873 10.1992 14.111C10.1992 14.8346 10.7866 15.4267 11.5045 15.4267Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_525_174" x="0" y="0" width="39" height="32.7024" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_525_174" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_525_174" result="shape" />
              </filter>
            </defs>
          </svg>

          CRA
        </h1>
        <!--begin::Menu-->

      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a [routerLink]="['/wegestu/profil-candidat']" class="text-muted"
            routerLinkActive="router-link-active">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted"><a class="text-muted" routerLink="/wegestu/pointage/cra">Liste CRA</a>
        </li>
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Activité </li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div>
  <div class="row cards mb-5">
    <div class="title-page mb-10">
      <h4>Activité </h4>
    </div>

    <div class="row actions-btns mb-5">
      <div class="actions">
        <a (click)="exportCra()" class="button download">
          <img src="/assets/media/icons/download.svg" alt="">
          Télécharger</a>

        <a *ngIf="displayValidationBtn(); else notValidationTurn" (click)="validateCra('3')" class="button validate">
          <img src="/assets/media/icons/check.svg" alt="">
          Valider</a>

        <ng-template #notValidationTurn>
            <a *ngIf="displayCancelBtn()" (click)="validateCra(null, true)" class="button cancel">
              <i class="fa-solid fa-ban iconeBan"></i> Annuler</a>
        </ng-template>
        

        <a *ngIf="displayValidationBtn()" class="button saved" data-bs-toggle="modal" data-bs-target="#compte">
          <i class="fa-solid fa-xmark iconeXmark"></i> Rejeter</a>
      </div>
    </div>
    <div id="downloadCra"   >
      <div class="d-flex cra-details">
    <div class="col-lg-3 padding-zero">
      <div class="left">
        <div class="title text-center">
          <h4>
            Client / Type d’activité
          </h4>
        </div>
        <div class="item" *ngFor="let listClient of listClientOfCra ; let i = index"
        [style.background-color]="listClient?.family ? getBackgroundColor(listClient.family) : null">
          <div class="item-name">
            <h4>{{listClient?.name}}</h4>
          </div>
        </div>
        <div class="item" *ngFor="let listCra of listOfCra ; let i = index"
        [style.background-color]="listCra?.family ? getBackgroundColor(listCra.family) : null"
        >
          <div class="item-name">
            <h4>{{listCra?.name}}</h4>
          </div>
        </div>

        <div class="item-total">
          <div class="item-name">
            <h4> Total journalier:</h4>
          </div>
        </div>
        <div class="alert alert-warning text-center mt-5" role="alert" *ngIf="listOfCra&&!listOfCra.length">
          <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
          <span class="empty-list">
            La liste est vide
          </span>
        </div>

      </div>
    </div>
    <div class="col-lg-9 padding-zero">
      <h4 class="title-month">{{listDetailsCraForMonths?.desiredCRA?.date | date: 'MMMM y'}}</h4>
      <div class="table-responsive">

        <table class="table table-cra">
          <thead>
            <th *ngFor="let day of generateDaysArray()" [class.weekend]="isWeekend(day)" [class.weekend]="isHoliday(day)">
              {{ day }}
            </th>
          </thead>

          <tbody>
            <tr *ngFor="let cra of listDetailsCraForMonths?.desiredCRA?.ligne_cra">

              <ng-container *ngFor="let day of cra.days; let j = index">
                <td [ngStyle]="{
                  'background-color': isWeekend(day.day) ? '#FDEFEE' : isHoliday(day.day) ? '#f4587a' : ''
              }">
          <ng-select class="ng-select-container" [items]="res" bindLabel="name" bindValue="id" id="dispo"
          [ngModel]="selectedValues[cra.type_id]?.[j].duration"
          [style.visibility]="(!isWeekend(day.day) && !isHoliday(day.day)) ? 'visible' : 'hidden'"
          [ngClass]="{
              'custom-ng-select': true,
              'option-value1': selectedValues[cra?.type_id]?.[j]?.duration == '1',
              'option-value2': selectedValues[cra?.type_id]?.[j]?.duration == '2',
              'option-value3': selectedValues[cra?.type_id]?.[j]?.duration == '3',
              'option-value4': selectedValues[cra?.type_id]?.[j]?.duration == '4'
          }"
          (ngModelChange)="updateSelectedValue($event, cra?.type_id, j)"
          disabled>
      </ng-select>

              </td>
              </ng-container>

            </tr>
          </tbody>
          <tfoot class="table-cra-total">
            <tr>
              <td *ngFor="let total of totalDurations; let dayIndex = index"
                  [ngStyle]="getTotalCellStyles(dayIndex, total)">
                {{ total }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
     </div>
    </div>
   </div>
  </div>

  <div class="card">
    <div class="title mb-5">
      <h4>Totaux</h4>
    </div>

    <div class="row">
      <div class="col-lg-3">
        <h4 class="category-box prod" style="text-align: center;">Production</h4>
        <div class="table-responsive">
          <table class="table" id="totaux">
            <tbody>
              <tr>
                <td><span class="color-blue">Total</span></td>
                <td>{{ totalDurationForAllFamilies && totalDurationForAllFamilies.Production ? totalDurationForAllFamilies.Production:'---'}} jours</td>
              </tr>
              <tr *ngFor="let item of getTotalDurationByType('Production')">
                <td><span class="color-blue">{{ item.type_name }}</span></td>
                <td>{{ item.total_duration }} jours</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div class="col-lg-3">
        <h4 class="category-box interne" style="text-align: center;">Interne</h4>
        <div class="table-responsive">
          <table class="table" id="totaux">
            <tbody>
              <tr>
                <td><span class="color-blue">Total</span></td>
                <td>{{ totalDurationForAllFamilies && totalDurationForAllFamilies.Interne?totalDurationForAllFamilies.Interne:'---' }} jours</td>
              </tr>
              <tr *ngFor="let item of getTotalDurationByType('Interne')">
                <td><span class="color-blue">{{ item.type_name }}</span></td>
                <td>{{ item.total_duration }} jours</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-3">
        <h4 class="category-box absence" style="text-align: center;">Absence</h4>
        <div class="table-responsive">
          <table class="table" id="totaux">
            <tbody>
              <tr>
                <td><span class="color-blue">Total</span></td>
                <td>{{ totalDurationForAllFamilies && totalDurationForAllFamilies.Absence?totalDurationForAllFamilies.Absence:'---' }} jours</td>
              </tr>
              <tr *ngFor="let item of getTotalDurationByType('Absence')">
                <td><span class="color-blue">{{ item.type_name }}</span></td>
                <td>{{ item.total_duration }} jours</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-3">
        <h4 class="category-box total" style="text-align: center;">Total</h4>
        <div class="table-responsive">
          <table class="table" id="totaux">
            <tbody>
              <tr>
                <td> <span class="color-blue">Nombre de jours</span></td>
                <td> <span class="color-blue">{{listDetailsCraForMonths?.desiredCRA?.totalDuration ? listDetailsCraForMonths?.desiredCRA?.totalDuration:'---'}} jours</span></td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<!--begin::Modal Reject CRA-->
<div class="modal fade" id="compte" tabindex="-1" aria-hidden="true">
  <!--begin::Modal dialog-->
  <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content pt-5  pb-15" >
          <!--begin::Modal header-->
          <div class="modal-header" >
              <!--begin::Modal title-->
              <h2 class="fw-bold">Rejeter CRA</h2>
              <!--end::Modal title-->
              <!--begin::Close-->
              <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
                  <i class="ki-duotone ki-cross fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                  </i>
              </div>
              <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body  mx-5 " [formGroup]="rejectForm">
              <quill-editor  [placeholder]="'Raison de rejet *'" formControlName="report" [modules]="{ toolbar: toolbarOptions }" style="width: 100%; height: 100px;" ></quill-editor>
          </div>
          <div class="card-footer text-center mx-5 mt-7">
              <div class="modal-actions-container">
                  <a (click)="closeModal()" class="annuler" data-bs-dismiss="modal" aria-label="Close" style="cursor: pointer;">Annuler</a>
                  <a  (click)="validateCra('4')" data-bs-dismiss="modal" aria-label="Close" class="confirmer ms-4" style="cursor: pointer;">Confirmer</a>
                </div>
          </div>
          <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
  </div>
  <!--end::Modal dialog-->
</div>


<!--end::Modal - Customers - Add-->
